<template>
  <div>
    <v-data-table
      class="custom-price-data-table gray10"
      :headers="headers"
      :items="items"
      :no-data-text="$t('common.nodata')"
      hide-default-footer
      fixed-header
      ref="table"
      :header-props="{ 'sort-icon': '$sortIcon' }"
    >
      <template v-slot:item.createTime="{ item }">
        {{ item.createTime | dateTimeFilter }}
      </template>
      <template v-slot:item.coin="{ item }">
        {{ item.coin.unit }}
      </template>
      <template v-slot:item.transactionType="{ item }">
        {{
          item.transactionType === "TRANSFER_FROM_MARKET_TO_EXCOINO"
            ? $t("withdraw.transferToExcoino")
            : item.transactionType === "WITHDRAW"
            ? $t("withdraw.withdraw")
            : ""
        }}
      </template>
    </v-data-table>
    <v-pagination
      class="custom-number-pagination"
      v-model="pageNo"
      :length="total"
      total-visible="6"
      @input="changePageNumber"
    ></v-pagination>
  </div>
</template>
<script>
import dayjs from "@/utiles/dayjs";

export default {
  name: "withdrawTable",
  props: {
    items: {
      type: Array
    },
    paginate: {
      type: Object
    }
  },
  filters: {
    dateTimeFilter(date) {
      return (
        dayjs(date).format("HH:mm") + " - " + dayjs(date).format("YYYY/MM/DD")
      );
    }
  },
  data() {
    return {
      pageNo: this.paginate.page,
      total: this.paginate.total,
      headers: [
        {
          text: this.$t("withdraw.withdrawTime"),
          value: "createTime",
          align: "center"
        },
        {
          text: this.$t("withdraw.crypto"),
          value: "coin",
          align: "center"
        },
        {
          text: this.$t("withdraw.status"),
          value: "statusString",
          align: "center"
        },
        {
          text: this.$t("withdraw.refCode"),
          value: "trackNumber",
          align: "center"
        },
        {
          text: this.$t("withdraw.withdrawType"),
          value: "transactionType",
          align: "center"
        }
      ]
    };
  },
  methods: {
    changePageNumber() {
      this.$emit("changePage", this.pageNo);
    }
  }
};
</script>
<style scoped lang="scss"></style>
